export default {
  licenseRetry: { failed: 'License verification could not be completed. Please try again.', dismiss: 'Dismiss' },
  locale: "en",
  landing: {
    hero: {
      title: "AI Revolution in Financial Analysis",
      subtitle: "Understand markets with AI, predict the future",
      cta: "Get Started",
      badge: "Turkey's Financial AI Platform",
    },
    about: {
      title: "About Formind",
      mainTitle: "AI-Powered Financial Assistant",
      mainDescription:
        "Formind is an AI-powered financial assistant developed specifically for Turkish financial markets. It combines real-time market data with historical data to provide analysis, forecasts, reporting, and comparisons in the financial and investment world in real-time.",
      summaryTitle: "Smart Solution for Institutions",
      summaryDescription:
        "Formind is an intelligent AI solution that provides institutions operating in the financial and investment sector with meaningful interpretation of complex data, strategic insights, and easy access to information.",
    },
    nav: {
      login: "Login",
      register: "Sign Up",
      chat: "Chat",
    },
    chat: {
      title: "Financial Analysis with AI Chat",
      description:
        "Query real-time market data, perform technical and fundamental analysis, track KAP notifications. Strengthen your financial decisions with AI-powered chat system.",
      feature1: "Real-time market data",
      feature2: "Technical and fundamental analysis",
      feature3: "KAP notifications tracking",
      feature4: "Sector comparisons",
    },
    mcp: {
      title: "Model Context Protocol (MCP)",
      description:
        "Access ForInvest market data in real-time and analyze it. Integrate your own AI models with MCP.",
      docs: "Documentation and Tools",
      card1Title: "Real-time Data Access",
      card1Desc: "Real-time access to market data",
      card2Title: "Financial Analysis",
      card2Desc: "Automated analysis and reporting",
    },
    api: {
      title: "API Access with Token Structure",
      description:
        "Build your own agentic structures, retrieve financial data, and develop custom applications. Secure API access with token-based authentication.",
      feature1: "RESTful API",
      feature2: "Token-based security",
      feature3: "Agentic structure support",
      feature4: "Detailed documentation",
      cta: "Start with API",
    },
    footer: "© 2025 ForAI. All rights reserved.",
  },
  common: {
    login: "Login",
    logout: "Logout",
    email: "Email",
    username: "Username",
    password: "Password",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    update: "Update",
    refresh: "Refresh",
    search: "Search",
    filter: "Filter",
    close: "Close",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    actions: "Actions",
    date: "Date",
    name: "Name",
    surname: "Surname",
    role: "Role",
    send: "Send",
    expand: "Expand",
    collapse: "Collapse",
    show: "Show",
    hide: "Hide",
    optional: "Optional",
    profile: "Profile",
    menu: "Menu",
    help: "Help",
  },
  auth: {
    welcome: "Welcome to ForMind",
    brandDescription: "AI-powered financial analysis platform. Strengthen your investment decisions with real-time market data, technical and fundamental analysis tools.",
    badgeAI: "AI-Powered Analysis",
    badgeRealtime: "Real-Time Data",
    badgeSecure: "Secure Infrastructure",
    loginTitle: "Login",
    loginSubtitle: "Sign in to your account to continue",
    registerTitle: "Sign Up",
    loggingIn: "Logging in...",
    registering: "Signing up...",
    register: "Sign Up",
    firstName: "First Name",
    lastName: "Last Name",
    usernameRequired: "Username and password are required",
    allFieldsRequired: "All fields are required",
    passwordsDoNotMatch: "Passwords do not match",
    loginFailed: "Login failed",
    loginError: "Error occurred during login",
    registerDisabled: "Registration is managed through ForInvest. Please login with your ForInvest account.",
    alreadyHaveAccount: "Already have an account?",
    registerSuccess: "Registration successful! You can now login.",
    confirmPassword: "Confirm Password",
  },
  dashboard: {
    welcome: "Welcome",
    welcomeMessage: "You have successfully logged into the ForMind platform.",
    userInfo: "User Information",
    administrator: "Administrator",
    client: "Client",
    testUser: "Test User",
  },
  sidebar: {
    home: "Home",
    aiChat: "AI Chat",
    userManagement: "User Management",
    benchmarks: "Benchmarks",
    profile: "My Profile",
    settings: "Settings",
    packageLimits: "Package Limits",
  },
  header: {
  },
  chat: {
    settings: "Settings",
    newChat: "New Chat",
    history: "History",
    starred: "Starred",
    noConversations: "No conversations yet",
    deleteConfirm: "Are you sure you want to delete this conversation?",
    addStar: "Add to Starred",
    removeStar: "Remove from Starred",
    rename: "Rename",
    conversationName: "Conversation Name",
    typeMessage: "Type your message...",
    chatModeLabel: "Response mode",
    chatModeAuto: "Automatic",
    chatModeAutoDescription: "Picks fast or advanced based on your question",
    chatModeFast: "Fast",
    chatModeFastDescription: "Quick answers for simple single-stock questions",
    chatModeAdvanced: "Advanced",
    chatModeAdvancedDescription: "Solves comprehensive or multi-stock questions",
    chatModeAutoSelected: "Auto mode",
    chatModeFastResult: "Generated in Fast mode",
    chatModeAdvancedResult: "Generated in Advanced mode",
    modelSelectorLabel: "Select model",
    adaptiveThinking: "Adaptive Thinking",
    adaptiveThinkingDescription: "Thinks deeper for complex tasks",
    rag: "Knowledge base (RAG)",
    ragDescription: "Includes your own uploaded documents in answers. Organization documents are always active.",
    attachMenu: "Attach",
    attachFiles: "Add files",
    listening: "Listening",
    finbotReady: "Finbot ready",
    voiceError: "Voice error",
    browserNotSupported: "Browser not supported",
    finbotWaiting: "Finbot waiting",
    hello: "Hello!",
    welcomeMessage:
      "Start chatting with your ForMind assistant. I'm happy to help you with investment and finance topics.",
    quickPrompts: "Quick Prompts - Fast Start",
    quickPromptsSubtitle: "Select one of the examples below to start analysis immediately",
    connectionSuccessful: "Connection Successful",
    disconnected: "Disconnected",
    connectionError: "Connection Error",
    wsConnectionClosed: "WebSocket connection closed. Please refresh the page.",
    wsConnectionError: "Connection error occurred. Please refresh the page.",
    toolsUsed: "tools used",
    referencesUsed: "References used",
    referenceUsed: "used",
    request: "Request",
    response: "Response",
    tokens: "tokens",
    startSpeaking: "Start speaking",
    voiceHint: "Leave a short silence when you finish speaking",
    running: "Running",
    success: "Success",
    failed: "Failed",
    startListening: "Start listening",
    stopListening: "Stop listening",
    howCanIHelp: "How can I help you today?",
    welcome: "Welcome",
    preparedQuestionsLoadError: "Prepared questions could not be loaded.",
    retry: "Retry",
    preparedQuestionUnavailable: "The selected prepared question is no longer available. The list was refreshed.",
    originalPrompt: "Original Prompt",
    proposedAnalysis: "Proposed Analysis Steps",
    cancel: "Cancel",
    proceed: "Proceed",
    mergingResults: "Merging results...",
    preparingResult: "Preparing Result",
    preparing: "Preparing...",
    collectingData: "Collecting Data",
    toolsRunning: "Tools Running",
    analyzingData: "Analyzing all data...",
    preparingAnswer: "Preparing your answer...",
    finalAnswerPreparing: "Data is compiled. Preparing the answer...",
    listenAudio: "Listen audio",
    downloadPDF: "Download as PDF",
    followUpQuestions: "Suggested follow-up questions",
    like: "Like",
    unlike: "Unlike",
    feedbackPlaceholder: "Tell us what went wrong (optional)",
    feedbackReceived: "Thanks, your feedback was received.",
    voiceCommandBusy:
      "Voice command cannot be processed right now, please wait for the current response.",
    promptRefineError: "Error occurred while refining prompt",
    connectionFailed: "Connection failed. Please refresh the page.",
    reconnecting: "Reconnecting...",
    ttsError: "Text-to-speech conversion failed",
    transcribing: "Converting speech to text...",
    requestingMic: "Requesting microphone access...",
    selectMicrophone: "Select microphone",
    microphone: "Microphone",
    defaultMicrophone: "Default microphone",
    noMicFound: "No microphone found",
    improvingPrompt: "Improving prompt...",
    refinePromptToggle: "Improve prompt",
    refinePromptDescription: "Improves your question before sending. Preview with Tab.",
    refinedPromptLabel: "Improved · Show original",
    refinePromptFallback: "Refinement failed; the original text was used.",
    refinePromptHint: "Refine prompt (Tab)",
    goodMorning: "Good Morning",
    goodEvening: "Good Evening",
    randomGreeting1: "Where shall we start?",
    randomGreeting2: "Let's dive into financial analysis.",
    randomGreeting3: "What can I do for you?",
    randomGreeting4: "Which analysis shall we run today?",
    randomGreeting5: "Let's take a look at the markets together.",
    deleteWarning: "This conversation will be permanently deleted.",
    deleteAll: "Delete All",
    deleteAllConfirm: "Are you sure you want to delete all conversations?",
    deleteAllError: "An error occurred while deleting conversations.",
    conversations: "Conversations",
    disclaimer: {
      title: "Important Notice",
      text: "AI may generate incorrect information. Please verify the accuracy of information before making investment decisions."
    },
    uploadFile: "Upload File",
    removeFile: "Remove File",
    fileTooLarge: "File size cannot exceed 50MB",
    unsupportedFileType: "Unsupported file type. Please select PDF, TXT, Word (.docx) or Excel (.xlsx, .xls) files",
    fileUploadError: "Error occurred while uploading file",
    stopGeneration: "Stop generation",
    stoppedMessage: "Response stopped",
    stoppingGeneration: "Stopping generation...",
    generationStopped: "Generation stopped",
    pleaseWait: "Please wait while we stop the current operation",
    limitExceededTitle: "Monthly Usage Limit Reached",
    creditExhaustedTitle: "Usage Credit Exhausted",
    creditExhaustedDesc: "You have no usage credit remaining. Review your plan or wait for your allowance to renew.",
    limitExceededDesc: "You have reached your monthly usage limit. Upgrade your plan to continue.",
    limitExceededUpgrade: "Upgrade Plan →",
    limitExceededProDesc: "Your available credit is exhausted. Contact support for additional usage credit.",
    limitRenewalDate: "Package renewal: {date}",
  },
  profile: {
    profile: "Profile",
    title: "My Profile Information",
    loadingProfile: "Loading profile information...",
    accountInfo: "Account Information",
    registrationDate: "Registration Date",
    tokenUsage: "Credit Usage",
    tokenBalance: "Credit Balance",
    usedToday: "Used Today",
    totalUsage: "Total Usage",
    used: "used",
    totalTokenUsage: "Monthly Token Usage",
    monthlyTokenCost: "Monthly Cost",
    date: "Date",
    model: "Model",
    agent: "Agent",
    cost: "Cost",
    apiKey: "API Key",
    hide: "Hide",
    show: "Show",
    copy: "Copy",
    copiedToClipboard: "Copied to clipboard",
    copyFailed: "Copy failed",
    changePassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    changing: "Changing...",
    passwordChanged: "Password changed successfully",
    fillAllFields: "Please fill all fields correctly",
    errorLoadingProfile: "Error loading profile information",
    preferences: "Preferences",
    language: "Language",
    security: "Security",
    agentPreferences: "Agent Preferences",
    customSystemPrompt: "Custom System Prompt (Max 1024 characters)",
    customPromptPlaceholder:
      "Define how you want the AI agent to behave (e.g., communication style, analysis depth, etc.)",
    preferencesSaved: "Preferences saved successfully",
    errorSavingPreferences: "Error saving preferences",
    saving: "Saving...",
    save: "Save",
    licenses: "Licenses",
    license: "License",
    loadingLicenses: "Loading licenses...",
    noLicenses: "No active licenses found",
    realtime: "Real-time",
    endOfDay: "End of Day",
    minutesDelay: "minutes delay",
    monthlyUsage: "Monthly Usage",
    limitOf: "${limit} limit",
    unlimited: "Unlimited",
    noAccess: "No Access",
    currentPlan: "Your Current Plan",
    upgrade: "Upgrade",
    planDesc: {
      Free: "Basic AI chat experience",
      Standard: "Analysis with standard market data",
      Trade: "Advanced trade data including MKK",
      Pro: "All data, maximum limit",
    },
    planFeature: {
      basicChat: "AI Financial Chat",
      limitedUsage: "Limited monthly usage",
      standardData: "BIST Composite & Spot data",
      standardUsage: "Standard monthly usage",
      tradeData: "BIST Composite & Spot data",
      mkk: "MKK data",
      tradeUsage: "Advanced monthly usage",
      proData: "All BIST data (L2, Dist, Index)",
      l2: "Depth (L2) data",
      proUsage: "Maximum monthly usage",
    },
  },
  users: {
    availableCredit: "Available Credit",
    walletBalance: "Wallet Total",
    additionalCreditHint: "Added credit provides usage beyond your package allowance. Unspent additional credit carries over to future periods.",
    title: "User Management",
    newUser: "New User",
    bulkAdd: "Bulk Add",
    bulkAddTitle: "Bulk Add Users",
    bulkJsonFile: "JSON File",
    bulkParsedCount: "{count} records found",
    bulkTokenNote: "All records are created with the customer role and a daily limit of 5,000,000 tokens.",
    bulkErrorTitle: "Errors",
    bulkMissingEmail: "Missing email",
    bulkExpiryRequired: "Secret key expiry date is required",
    bulkCreate: "Create in Bulk",
    bulkCreating: "Creating in Bulk...",
    bulkInvalidFormat: "JSON must be an array",
    bulkInvalidJson: "Could not read JSON file",
    bulkNoUsers: "No records found for bulk add",
    bulkSuccess: "{count} users created successfully",
    bulkPartial: "{created} users created, {failed} failed",
    bulkAllFailed: "No users could be created",
    bulkError: "Error creating users in bulk",
    tokenBalance: "Credit Balance",
    dailyTokenUsage: "Used Today",
    totalTokenUsage: "Total Usage",
    createUser: "Create New User",
    editUser: "Edit User",
    changeUserPassword: "Change User Password",
    user: "User",
    regenerateKeys: "Regenerate Keys",
    regenerateConfirm: "Are you sure you want to regenerate API keys for user?",
    deleteConfirm: "Are you sure you want to delete user?",
    creating: "Creating...",
    updating: "Updating...",
    userCreated: "User created successfully",
    userUpdated: "User updated successfully",
    userDeleted: "User deleted successfully",
    keysRegenerated: "API keys regenerated successfully",
    newApiKey: "New API Key",
    keyWarning: "This key is shown only once. Please store it in a safe place.",
    passwordsNotMatch: "New passwords do not match",
    passwordTooShort: "New password must be at least 6 characters",
    passwordChangedSuccess: "User password changed successfully",
    administrator: "Administrator",
    customer: "Customer",
    test: "Test",
    enterNewPassword: "Enter new password",
    reenterNewPassword: "Re-enter new password",
    errorLoadingUsers: "Error loading users",
    errorCreatingUser: "Error creating user",
    errorUpdatingUser: "Error updating user",
    creditBalanceChanged: "The balance changed. Reopen the user from the updated list and review the current balance before saving.",
    errorDeletingUser: "Error deleting user",
    errorRegeneratingKeys: "Error regenerating keys",
    errorChangingPassword: "Error changing password",
    viewChats: "View Chats",
    chatConversations: "Chat Conversations",
    loadingChats: "Loading chats...",
    noChatsFound: "No chats found for this user",
    untitledChat: "Untitled Chat",
    messages: "messages",
    assistant: "Assistant",
    errorLoadingChats: "Error loading chats",
    toolsUsed: "Tools Used",
    viewDetails: "View Details",
    request: "Request",
    response: "Response",
    addTokens: "Add Credits",
    currentBalance: "Current Balance",
    tokenAmount: "Credit Amount",
    enterTokenAmount: "Enter credit amount",
    description: "Description",
    tokenDescription: "E.g: Promotional credit, payment, etc.",
    newBalance: "New Balance",
    adding: "Adding...",
    invalidTokenAmount: "Please enter a valid credit amount",
    errorAddingTokens: "Error occurred while adding credits",
  },
  settings: {
    title: "Settings",
    tokenPricing: "Token Pricing",
    tokenPricePerUnit: "Token Price Per Unit",
    currentPrice: "Current Price",
    newPrice: "New Price",
    save: "Save",
    saving: "Saving...",
    success: "Settings updated successfully",
    error: "Error updating settings",
    invalidPrice: "Please enter a valid price",
  },
  packageLimits: {
    title: "Package Limits",
    subtitle: "Set monthly token (cost) limits for each license package",
    loading: "Loading package limits...",
    monthlyLimit: "Monthly Limit (USD)",
    unlimited: "Unlimited (-1 = no limit)",
    noAccess: "No Access (0 = blocked)",
    limitHint: "User can spend ${val} this month",
    unlimitedHint: "-1 = unlimited, 0 = no access",
    save: "Save",
    saving: "Saving...",
    saveSuccess: "{pkg} package updated successfully",
    saveError: "Error saving limit",
    loadError: "Failed to load package limits",
  },
  modelManagement: {
    pipelineEyebrow: "PIPELINE CONFIGURATION",
    pipelineTitle: "Pipeline assignments",
    pipelineDescription: "Choose the model assigned to each stage. Advanced settings appear when you expand a row; changes are saved automatically.",
    assignedRoles: "assigned roles",
    assignedModel: "Assigned model",
    customAssignment: "Custom assignment",
    defaultAssignment: "Default",
    jevTitle: "JEV Skill Selector",
    jevHelp: "Use JEV before skill selection",
    jevModel: "JEV model",
    selectJevModel: "Select a JEV model",
    jevThreshold: "Threshold (%)",
    unavailable: "unavailable",
    enabled: "On",
    disabled: "Off",
    send: "Send",
    autoSaveNote: "Changes are saved automatically when you leave a field.",
  },
  pipelineCalculator: {
    eyebrow: "PIPELINE COST ESTIMATE",
    title: "Pipeline pricing calculator",
    subtitle: "Estimate assigned model costs, token scenarios and package-limit impact together.",
    loading: "Loading model prices...",
    refresh: "Refresh prices",
    errorTitle: "Prices unavailable",
    retry: "Try again",
    errorDescription: "Pipeline pricing is currently unavailable.",
    runsLabel: "Run count",
    runsHint: "Total pipeline runs for the selected scenario",
    cacheIncluded: "Cache tokens included in input total",
    cacheIncludedHint: "Matches the AgentCore cost formula",
    priceUnit: "Price unit",
    roleBreakdown: "ROLE-BASED CALCULATION",
    roleBreakdownTitle: "Pipeline cost breakdown",
    roleBreakdownHint: "Expand a role to edit call and token assumptions",
    unavailable: "No price",
    perRun: "/ run",
    customAssignment: "Custom assignment",
    defaultAssignment: "Default model",
    priceUnavailable: "No price found for this model",
    callsLabel: "Calls / run",
    inputLabel: "Input tokens / call",
    outputLabel: "Output tokens / call",
    cachedInputLabel: "Cached input / call",
    cacheWriteLabel: "Cache write / call",
    roleEstimate: "Estimated role cost",
    run: "run",
    needsPrice: "Pricing required",
    estimatedTotal: "Estimated total cost",
    runs: "runs",
    incompleteWarning: "Roles without pricing are excluded from the total.",
    perRunTotal: "Known total per run",
    knownCost: "Total for roles with pricing",
    modelBreakdown: "Model breakdown",
    noModels: "No calculable model found.",
    packageImpact: "Package-limit impact",
    monthly: "scenario",
    unlimited: "Unlimited",
    disclaimer: "These are scenario estimates; actual cost varies with realized token usage and pipeline flow.",
    noModel: "No model assigned",
  },
  tokenPricing: {
    title: "Token Pricing",
    subtitle: "Manage AI model token prices",
    inputTokenPrice: "Input Token Price",
    outputTokenPrice: "Output Token Price",
    loadFailed: "Failed to load prices",
    saveSuccess: "Prices saved successfully",
    saveFailed: "Save failed",
    saveAll: "Save All",
    saveAllSuccess: "All prices saved",
    totalModels: "Total Models",
    avgInputPrice: "Avg. Input Price",
    avgOutputPrice: "Avg. Output Price",
    exampleCost: "10M Token Cost",
    priceComparison: "Model Price Comparison",
    estimatedCostChart: "Estimated Cost Chart",
    examplePrompt: "Example Prompt",
    samplePromptText: "Analyze the top 5 highest volume stocks in BIST 100 index",
    estimatedInput: "Estimated Input",
    estimatedOutput: "Estimated Output",
    estimatedCostPerPrompt: "Estimated Cost / Prompt",
    priceCalculator: "Price Calculator",
    selectModel: "Select Model",
    inputTokenCount: "Input Token Count",
    outputTokenCount: "Output Token Count",
    inputCost: "Input Cost",
    outputCost: "Output Cost",
    totalCost: "Total Cost",
    modelPrices: "Model Prices",
    model: "Model",
    status: "Status",
    cost10M: "10M Token Cost",
  },
  benchmark: {
    title: "Benchmark Management",
    subtitle: "Upload Excel files to review and edit results.",
    new: "New Benchmark",
    newHint: "Upload the Excel file and detect model columns automatically.",
    nameLabel: "Benchmark Name",
    namePlaceholder: "e.g. Q4 2024 Model Comparison",
    fileLabel: "Excel File",
    upload: "Upload",
    uploading: "Uploading...",
    empty: "No benchmarks yet.",
    detailTitle: "Benchmark Details",
    detailSubtitle: "Edit rows and preview HTML answers.",
    columns: {
      name: "Benchmark Name",
      uploadDate: "Upload Date",
      avgScore: "Average Score",
      accuracy: "Correct/Total",
      soru: "Question",
      kategori: "Category",
      referansCevap: "Reference Answer",
      referansTarihi: "Reference Date",
      ajanCevabi: "Agent Answer",
      score: "Score",
      reason: "Reason",
      dogruluk: "Accuracy",
      sure: "Duration (sec)",
      actions: "Actions",
    },
    actions: {
      open: "Open",
      addRow: "+ New Row",
      addColumn: "+ New Column",
      preview: "Preview",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      refresh: "Refresh",
      delete: "Delete",
      deleteRow: "Delete Row",
      deleteColumn: "Delete Column",
      settings: "Column Settings",
    },
    fields: {
      columnName: "Column Name",
      cellColor: "Cell Color",
      columnPosition: "Column Position",
      rowPosition: "Row Position",
    },
    colors: {
      none: "None",
      green: "Green",
      red: "Red",
    },
    positions: {
      end: "Add to end",
      top: "Add to top",
      afterRow: "After: {label}",
      afterColumn: "After: {label}",
    },
    messages: {
      uploadSuccess: "Benchmark uploaded successfully.",
      updateSuccess: "Update saved.",
      addRowSuccess: "New row added.",
      deleteSuccess: "Benchmark deleted.",
      deleteRowSuccess: "Row deleted.",
      deleteColumnSuccess: "Column deleted.",
      addColumnSuccess: "New column added.",
      updateColumnSuccess: "Column updated.",
      updateColorSuccess: "Cell color updated.",
      confirmDeleteRow: "Delete row: {label}?",
      confirmDeleteColumn: "Delete column: {label}?",
    },
    errors: {
      fetchFailed: "Unable to load benchmark list.",
      uploadFailed: "Failed to upload benchmark.",
      missingUpload: "Benchmark name and file are required.",
      fetchDetailFailed: "Unable to load benchmark details.",
      updateFailed: "Failed to update row.",
      addRowFailed: "Failed to add row.",
      deleteFailed: "Failed to delete benchmark.",
      deleteRowFailed: "Failed to delete row.",
      deleteColumnFailed: "Failed to delete column.",
      addColumnFailed: "Failed to add column.",
      updateColumnFailed: "Failed to update column.",
      updateColorFailed: "Failed to update cell color.",
    },
  },
  tour: {
    startTour: "Start Guided Tour",
    next: "Next",
    previous: "Previous",
    done: "Done",
    close: "Close",
    chat: {
      newConversation: {
        title: "New Chat",
        description:
          "Click this button to start a new conversation. Each new chat opens a fresh page.",
      },
      history: {
        title: "Chat History",
        description:
          "Access your previous conversations here. You can star, rename, or delete your chats.",
      },
      profile: {
        title: "Profile",
        description:
          "Click this button to go to your profile page. Manage your account information and preferences here.",
      },
      examples: {
        title: "Example Questions",
        description:
          "Use ready-made question categories for a quick start. Fundamental analysis, technical analysis, markets, and more.",
      },
    },
  },
  myDocuments: {
    title: "My documents",
    description: "Documents you upload are used only in your own chats. No other user can see them.",
    supportedTypes: "TXT, Markdown and PDF",
    quota: "documents",
    upload: {
      title: "Upload a document",
      description: "Up to {size} MB per file. TXT, Markdown and PDF are supported.",
      choose: "Choose a file",
      submit: "Upload",
      uploading: "Uploading…",
      limitReached: "You have reached the limit of {limit} documents. Delete one before uploading a new document.",
    },
    list: {
      title: "Your documents",
      refresh: "Refresh",
      loading: "Loading documents…",
      empty: "You have not uploaded any documents yet.",
      chunks: "{count} chunks",
      delete: "Delete",
      deleteLabel: "Delete document {name}",
      deleteConfirm: "Delete \"{name}\"?",
    },
    notifications: {
      uploaded: "\"{name}\" uploaded.",
      replaced: "\"{name}\" updated.",
      deleted: "\"{name}\" deleted.",
    },
  },
  rag: {
    chunking: {
      title: "Chunking",
      description: "Decide how the document is split before it is stored. The preview shows exactly the chunks that will be written.",
      strategy: "Strategy",
      strategies: {
        recursive: "Recursive",
        paragraph: "Paragraph",
        sentence: "Sentence",
        fixed: "Fixed width",
        markdown: "Markdown headings",
      },
      strategyHints: {
        recursive: "Tries paragraph, line, sentence and word boundaries in order. Recommended default.",
        paragraph: "Splits on blank lines only, hard-wrapping paragraphs that exceed the limit.",
        sentence: "Packs whole sentences up to the limit without splitting them.",
        fixed: "Creates fixed-width windows, ignoring document structure.",
        markdown: "Splits on headings first, then recursively inside long sections.",
      },
      chunkSize: "Chunk size (characters)",
      chunkOverlap: "Overlap (characters)",
      minChunkChars: "Minimum chunk (characters)",
      minChunkCharsHint: "Chunks below this size are merged into the previous one.",
      stripWhitespace: "Trim whitespace around each chunk",
      reset: "Reset to defaults",
      errors: {
        chunkSize: "Chunk size must be between {min} and {max}.",
        chunkOverlap: "Overlap cannot be negative.",
        overlapTooLarge: "Overlap must be smaller than the chunk size.",
        minChunkChars: "Minimum chunk must be between 1 and the chunk size.",
      },
    },
    title: "RAG Documents",
    description: "Manage drafts and vector records using known keys.",
    tabs: { label: "RAG sections", list: "Vector list and search", manage: "Document management" },
    search: { title: "Vector search trial", description: "Send a query to inspect the closest records.", query: "Query", topK: "Result count", submit: "Search", loading: "Searching…", empty: "No results found.", distance: "Distance: {distance}" },
    delete: { action: "Delete", loading: "Deleting…", confirm: "Delete the \"{key}\" record?", success: "Vector record deleted." },
    dialog: { close: "Close vector details" },
    list: {
      title: "Vector records",
      description: "Review provider records with metadata. Raw vector data is never shown.",
      refresh: "Refresh",
      loading: "Loading records…",
      empty: "No vector records found yet.",
      next: "Next page",
      metadataCount: "{count} metadata fields",
      dataIncluded: "Vector data exists",
      dataHidden: "Raw vector hidden",
      sourceText: "Source text",
      count: "{count} records",
      caption: "RAG vector records table",
      selected: "Selected",
      select: "View details",
      edit: "Edit",
      loadingDetails: "Loading…",
      noSource: "No source text",
      dimensions: "{count} dimensions",
      dimensionsLabel: "Dimensions",
      bucketLabel: "Bucket",
      selectedRecord: "Selected record",
      columns: {
        key: "Key",
        metadata: "Metadata summary",
        source: "Source text preview",
        data: "Dimensions / data status",
        actions: "Actions"
      }
    },
    upload: {
      title: "Upload document",
      description: "Choose a TXT, Markdown, or PDF file. Maximum 10 MB.",
      selectedFile: "Selected file: {name}",
      preview: "Preview",
      loading: "Previewing…",
      unsupportedType: "Unsupported file type. Choose TXT, Markdown, or PDF.",
      tooLarge: "File size cannot exceed 10 MB."
    },
    supportedTypes: "TXT, Markdown, or PDF",
    draft: {
      title: "Draft: {fileName}",
      summary: "{mimeType} · {count} chunks",
      chunk: "Chunk {number}",
      key: "Key",
      text: "Text",
      metadata: "Metadata",
      metadataKey: "Metadata key",
      metadataValue: "Metadata value",
      remove: "Remove",
      add: "Add"
    },
    actions: {
      title: "Draft actions",
      confirm: "Confirm draft",
      confirming: "Confirming…",
      clear: "Clear"
    },
    known: {
      title: "Known key operations",
      description: "Open a record from the table or by key in the edit dialog.",
      edit: "Edit",
      key: "Key",
      get: "Get",
      upsert: "Update",
      delete: "Delete",
      text: "Single upsert text",
      metadata: "Metadata JSON",
      batchKeys: "Known keys to delete (one per line)",
      deleteBatch: "Delete known keys in bulk",
      deleteConfirm: "Delete the \"{key}\" record?",
      result: "Known vector result"
    },
    result: {
      title: "Operation result",
      total: "Total: {count}",
      succeeded: "Succeeded: {count}",
      failed: "Failed: {count}",
      partial: "Some operations failed. Automatic retry is disabled.",
      retry: "Retry failed items",
      dimensions: "{count} dimensions",
      status: "Status: {status}",
      batch: "batch {index}"
    },
    notifications: {
      previewReady: "Preview is ready. No provider record was created.",
      confirmed: "Draft confirmed.",
      partial: "Operation partially completed.",
      fetched: "Vector record fetched.",
      updated: "Vector record updated.",
      deleted: "Vector record deleted.",
      notFound: "The vector record could not be deleted because it was not found.",
      batchDeleted: "Known key records deleted."
    },
    errors: {
      invalidFileType: "Unsupported file type.",
      emptyDocument: "No meaningful text could be extracted from the document.",
      fileTooLarge: "The file exceeds the permitted size limit.",
      invalidKey: "The key is invalid.",
      invalidMetadata: "Metadata JSON is invalid.",
      batchLimitExceeded: "The batch operation limit was exceeded.",
      providerNotFound: "Record not found.",
      providerTimeout: "The provider timed out. Please try again.",
      providerUnavailable: "The provider is unavailable. Please try again.",
      providerInvalidResponse: "The provider returned an invalid response.",
      documentLimitExceeded: "Document limit reached. Delete a document before uploading a new one.",
      validation: "The entered values are invalid.",
      generic: "The operation could not be completed. Please try again."
    }
  },
  widgets: {
    commons: {
      search: "Search",
      ok: "OK",
      selectSymbol: "Select Symbol",
      selectField: "Select Field",
      selected: "selected",
      noResults: "No results found",
      follow: "Follow",
      unfollow: "Unfollow",
      all: "All",
      results: "results"
    },
    technicalAnalysis: {
      title: "Technical Analysis",
      "5YM": "5 Years (Monthly)",
      "1YW": "1 Year (Weekly)",
      "6M5D": "6 Months (5 Days)",
      "1MD": "1 Month (Daily)",
      "1D5": "1 Day (5 Minutes)",
      "1H1": "1 Hour (1 Minute)"
    },
    depth: {
      title: "Depth",
      viewDepthTransaction: "Depth + Transactions",
      viewDepth: "Depth",
      viewTransaction: "Transactions",
      bid: "Bid",
      ask: "Ask",
      last: "Last",
      dailyWeightedAverage: "Daily Weighted Average",
      dailyChangePercentage: "Daily Change %",
      time: "Time",
      order: "Order",
      quantity: "Quantity",
      total: "Total"
    },
    transactions: {
      time: "Time",
      price: "Price",
      amount: "Amount",
      dchg: "Change %",
      turnover: "Turnover",
      last: "Last",
      volume: "Volume"
    },
    companyInfo: {
      title: "Company Information",
      code: "Code",
      companyName: "Company Name",
      establishmentDate: "Establishment Date",
      ipoDate: "IPO Date",
      registeredCapital: "Registered Capital",
      fieldOfActivity: "Field of Activity",
      numberOfEmployee: "Number of Employees",
      generalManager: "General Manager",
      contact: "Contact",
      address: "Address",
      phone: "Phone",
      fax: "Fax",
      website: "Website",
      boardMembers: "Board Members",
      shareholdersRates: "Shareholder Structure",
      shareholders: "Shareholders",
      subsidiaries: "Subsidiaries & Participations",
      exchangePosition: "Exchange Position"
    },
    levelAnalysis: {
      title: "Level Analysis",
      noData: "No data available",
      weightedAverage: "Weighted Average",
      totalLot: "Total Lot",
      averageBid: "Average Bid",
      averageAsk: "Average Ask",
      price: "Price",
      lot: "Lot",
      percent: "Percent",
      percentBid: "Bid %",
      percentAsk: "Ask %"
    },
    advancedGrid: {
      title: "Advanced Grid",
      tableView: "Table",
      gridView: "Grid",
      search: "Search symbol...",
      noData: "No data available",
      addSymbol: "Add Symbol",
      editFields: "Edit Fields",
      fields: {
        E: "Symbol",
        l: "Last",
        C: "Change %",
        b: "Bid",
        a: "Ask",
        t: "Time",
        o: "Open",
        h: "High",
        lo: "Low",
        v: "Volume",
        V: "Turnover",
        De: "Description"
      }
    },
    heatMap: {
      title: "Heat Map",
      tableView: "Table",
      chartView: "Chart",
      notFoundData: "No data available",
      symbol: "Symbol",
      last: "Last",
      change: "Change %",
      weightedAverage: "Weighted Avg %"
    },
    rag: {
    title: "RAG Documents",
    description: "Manage drafts and vector records using known keys.",
    tabs: { label: "RAG sections", list: "Vector list and search", manage: "Document management" },
    search: { title: "Vector search trial", description: "Send a query to inspect the closest records.", query: "Query", topK: "Result count", submit: "Search", loading: "Searching…", empty: "No results found.", distance: "Distance: {distance}" },
    delete: { action: "Delete", loading: "Deleting…", confirm: "Delete the \"{key}\" record?", success: "Vector record deleted." },
    dialog: { close: "Close vector details" },
    list: {
      title: "Vector records",
      description: "Review provider records with metadata. Raw vector data is never shown.",
      refresh: "Refresh",
      loading: "Loading records…",
      empty: "No vector records found yet.",
      next: "Next page",
      metadataCount: "{count} metadata fields",
      dataIncluded: "Vector data exists",
      dataHidden: "Raw vector hidden",
      sourceText: "Source text",
      count: "{count} records",
      caption: "RAG vector records table",
      selected: "Selected",
      select: "View details",
      edit: "Edit",
      loadingDetails: "Loading…",
      noSource: "No source text",
      dimensions: "{count} dimensions",
      dimensionsLabel: "Dimensions",
      bucketLabel: "Bucket",
      selectedRecord: "Selected record",
      columns: {
        key: "Key",
        metadata: "Metadata summary",
        source: "Source text preview",
        data: "Dimensions / data status",
        actions: "Actions"
      }
    },
    upload: {
      title: "Upload document",
      description: "Choose a TXT, Markdown, or PDF file. Maximum 10 MB.",
      selectedFile: "Selected file: {name}",
      preview: "Preview",
      loading: "Previewing…",
      unsupportedType: "Unsupported file type. Choose TXT, Markdown, or PDF.",
      tooLarge: "File size cannot exceed 10 MB."
    },
    supportedTypes: "TXT, Markdown, or PDF",
    draft: {
      title: "Draft: {fileName}",
      summary: "{mimeType} · {count} chunks",
      chunk: "Chunk {number}",
      key: "Key",
      text: "Text",
      metadata: "Metadata",
      metadataKey: "Metadata key",
      metadataValue: "Metadata value",
      remove: "Remove",
      add: "Add"
    },
    actions: {
      title: "Draft actions",
      confirm: "Confirm draft",
      confirming: "Confirming…",
      clear: "Clear"
    },
    known: {
      title: "Known key operations",
      description: "Open a record from the table or by key in the edit dialog.",
      edit: "Edit",
      key: "Key",
      get: "Get",
      upsert: "Update",
      delete: "Delete",
      text: "Single upsert text",
      metadata: "Metadata JSON",
      batchKeys: "Known keys to delete (one per line)",
      deleteBatch: "Delete known keys in bulk",
      deleteConfirm: "Delete the \"{key}\" record?",
      result: "Known vector result"
    },
    result: {
      title: "Operation result",
      total: "Total: {count}",
      succeeded: "Succeeded: {count}",
      failed: "Failed: {count}",
      partial: "Some operations failed. Automatic retry is disabled.",
      retry: "Retry failed items",
      dimensions: "{count} dimensions",
      status: "Status: {status}",
      batch: "batch {index}"
    },
    notifications: {
      previewReady: "Preview is ready. No provider record was created.",
      confirmed: "Draft confirmed.",
      partial: "Operation partially completed.",
      fetched: "Vector record fetched.",
      updated: "Vector record updated.",
      deleted: "Vector record deleted.",
      notFound: "The vector record could not be deleted because it was not found.",
      batchDeleted: "Known key records deleted."
    },
    errors: {
      invalidFileType: "Unsupported file type.",
      emptyDocument: "No meaningful text could be extracted from the document.",
      fileTooLarge: "The file exceeds the permitted size limit.",
      invalidKey: "The key is invalid.",
      invalidMetadata: "Metadata JSON is invalid.",
      batchLimitExceeded: "The batch operation limit was exceeded.",
      providerNotFound: "Record not found.",
      providerTimeout: "The provider timed out. Please try again.",
      providerUnavailable: "The provider is unavailable. Please try again.",
      providerInvalidResponse: "The provider returned an invalid response.",
      validation: "The entered values are invalid.",
      generic: "The operation could not be completed. Please try again."
    }
  },
  symbolDetails: {
      title: "Symbol Details",
      follow: "Follow",
      unfollow: "Unfollow",
      dailyChange: "Daily Change",
      weeklyChange: "Weekly Change",
      monthlyChange: "Monthly Change",
      yearlyChange: "Yearly Change",
      newWindow: "New Window",
      search: "Search",
      fields: "Fields",
      chart: "Mini Chart",
      quickOrder: "Quick Order"
    }
  },
  exchanges: {
    BIST: "Borsa Istanbul",
    VIOP: "Futures and Options",
    SPOT: "Spot Market",
    TCMB: "Central Bank of Turkey",
    FX: "Foreign Exchange",
    ForeignIndex: "Foreign Indices",
    Cryptocurrency: "Cryptocurrency"
  },
  licenses: {
    LIC_BIST_INDEX_MINI_EXT: "BIST Index Mini (Extended)",
    LIC_VIP_L1P: "VIP Level 1 Premium",
    LIC_BIST_L1P: "BIST Level 1 Premium",
    LIC_VIP_L2: "VIP Level 2",
    LIC_BIST_L2: "BIST Level 2",
    LIC_TEKNIK_ANALIZ: "Technical Analysis",
    LIC_NEWS_PICNEWS: "News - PicNews",
    LIC_NEWS_FRKS_INTERNAL: "News - Foreks Internal",
    LIC_TIME: "Time Data",
    LIC_BIST_BOND_L1P: "BIST Bond Level 1 Premium",
    LIC_VIP_L1_FREE: "VIP Level 1 Free",
    LIC_EXCHANGE_BIST: "Borsa Istanbul",
    LIC_BIST_KMTP_L2: "BIST KMTP Level 2",
    LIC_CBT: "Futures",
    LIC_SPOT: "Spot Market",
    LIC_CUSTODY: "Custody",
    LIC_FIDES_PARITE: "Fides Parity",
    LIC_FIDES_LIBOR: "Fides LIBOR",
    LIC_NEWS_AA: "News - Anadolu Agency",
    LIC_FIDES_INDEX: "Fides Index",
    LIC_INTERBANK: "Interbank",
    LIC_BIST_L2P: "BIST Level 2 Premium",
    LIC_BIST_INDEX: "BIST Index",
    LIC_BIST_DIST: "BIST Distribution",
    LIC_FXEXPLORER: "FX Explorer",
    LIC_OPSP_L1: "Options Level 1",
    LIC_OPSP_L2: "Options Level 2",
    LIC_USAGBY: "US Treasury Bonds",
    LIC_CBOE_EDGX: "CBOE EDGX",
    LIC_CBOE_DXE: "CBOE DXE",
    LIC_CBOE_CXE: "CBOE CXE",
    LIC_BIST_BOND_CONSOLIDATED: "BIST Bond Consolidated",
    LIC_BOVESPA: "Bovespa",
    LIC_MSCI: "MSCI Indices",
    LIC_PRODUCT_DESKTOP_FXPLUS: "Product - Desktop FX Plus",
    LIC_PRODUCT_WEB_FOREKSTRADER: "Product - Web ForeksTrader",
    LIC_PRODUCT_MOBILE_FOREKSTRADER: "Product - Mobile ForeksTrader",
    LIC_TEFASFUND_AND_EUROBOND: "TEFAS Fund and Eurobond",
    LIC_ATHENS_INDEX: "Athens Indices",
    LIC_BIST_ETP: "BIST ETP",
    LIC_VIP_BASIC: "VIP Basic",
    LIC_NEWS_KAP: "News - KAP",
    LIC_NEWS_FRKS: "News - Foreks",
    LIC_MKK: "MKK",
    LIC_NEWS_IHA: "News - IHA",
    LIC_SETTLEMENT: "Settlement",
    LIC_BIST_KMTP_L1: "BIST KMTP Level 1",
    LIC_KYD: "KYD",
    LIC_BIST_KMTP_L1P: "BIST KMTP Level 1 Premium",
    LIC_BIST_EXT: "BIST Extended",
    LIC_VIP_EXT: "VIP Extended",
    LIC_BOND_EXT: "Bond Extended",
    LIC_CALENDAR: "Calendar",
    LIC_DJ_INDEX: "Dow Jones Indices",
    LIC_VIP_L2P: "VIP Level 2 Premium",
    LIC_PING_PONG: "Ping Pong",
    LIC_VIP_DIST: "VIP Distribution",
    LIC_FTSE_INDEX: "FTSE Indices",
    LIC_SP_INDEX: "S&P Indices",
    LIC_EUX: "Eurex",
    LIC_NIKKEI_INDEX: "Nikkei Indices",
    LIC_BIST_L1: "BIST Level 1",
    LIC_SWISS_INDEX: "Swiss Indices",
    LIC_BIST_BOND_L1: "BIST Bond Level 1",
    LIC_BIST_INDEX_MINI_BASE: "BIST Index Mini (Base)",
    LIC_VIP_L1: "VIP Level 1"
  },
  fields: {
    CODE: "Symbol",
    TIME: "Time",
    SERIALCODE: "Serial Code",
    SHORTMARKETCODE: "Market Code",
    OPEN: "Open",
    VWAP: "VWAP",
    TRADETYPE: "Trade Type",
    BUYERCODE: "Buyer Code",
    SELLERCODE: "Seller Code",
    TRADENUMBER: "Trade No",
    PRICE: "Price",
    SIZE: "Last Volume",
    TRADETIME: "Trade Time",
    TRANSACTIONDIRECTION: "Transaction Direction",
    TRADEDVALUE: "Traded Value",
    BIDORASKDIRECTION: "Bid Or Ask Direction",
    LASTDIRECTION: "Last Direction",
    PREVIOUSDIRECTION: "Previous Direction",
    LAST: "Last",
    DATEEX: "DateEx",
    NETCHANGE: "Net Change",
    NETCHANGEPERCENT: "Net Change Percent",
    EVALUATIONDATE: "Evoluation Date",
    OFFICIALCLOSE: "Official Close",
    PROMPTDATE: "Prompt Date",
    PREVIOUSLAST: "Previous Last",
    VOLUME: "Volume",
    TURNOVER: "Turnover",
    DAILYCHANGE: "D.Chg",
    DAILYCHANGEPERCENT: "D.Chg %",
    WEEKLYCHANGE: "W.Chg",
    WEEKLYCHANGEPERCENT: "W.Chg %",
    MONTHLYCHANGE: "M.Chg",
    MONTHLYCHANGEPERCENT: "M.Chg %",
    YEARLYCHANGE: "Y.Chg",
    YEARLYCHANGEPERCENT: "Y.Chg %",
    DIRECTION: "Direction",
    BID: "Bid",
    ASK: "Ask",
    LOW: "Low",
    HIGH: "High",
    MIDPRICE: "Mid. Price",
    VOLATILITY: "Volatility",
    MMCODE: "MM. Code",
    MMBIDQUOTATION: "MM. Bid Quotation",
    MMASKQUOTATION: "MM. Ask Quotation",
    MMBIDQUOTATIONAMOUNT: "MM. Bid Quotation Volume",
    MMASKQUOTATIONAMOUNT: "MM. Ask Quotation Volume",
    WTDLOW: "Weekly Low",
    WTDHIGH: "Weekly High",
    PREVIOUSWEEKCLOSE: "Previous Week Close",
    MTDLOW: "Monthly Low",
    MTDHIGH: "Monthly High",
    PREVIOUSMONTHCLOSE: "Previous Month Close",
    YTDLOW: "YTD Low",
    YTDHIGH: "YTD High",
    PREVIOUSYEARCLOSE: "Previous Year Close",
    CLOSE: "Close",
    PREVIOUSCLOSE: "Previous Close",
    CLOSINGSESSIONPRICE: "Closing Session Price",
    LOWERLIMIT: "Lower Limit",
    UPPERLIMIT: "Upper Limit",
    TICKSIZE: "Tick Size",
    GROUP: "Group",
    BASEPRICE: "Base Price",
    TRADINGMETHOD: "Trading Method",
    STATUS: "Status",
    TOTALTURNOVER: "Total Turnover",
    TOTALVOLUME: "Total Volume",
    BIDRATIO: "Bid Ratio",
    ASKRATIO: "Ask Ratio",
    BIDVWAP: "Bid VWAP",
    BIDTOTALAMOUNT: "Bid Total Volume",
    ASKVWAP: "Ask VWAP",
    ASKTOTALAMOUNT: "Ask Total Volume",
    PERIODICVWAP: "Periodic VWAP",
    BIDPRICE0: "Bid Price 0",
    BIDPRICE1: "Bid Price 1",
    BIDPRICE2: "Bid Price 2",
    BIDPRICE3: "Bid Price 3",
    BIDPRICE4: "Bid Price 4",
    BIDPRICE5: "Bid Price 5",
    BIDPRICE6: "Bid Price 6",
    BIDPRICE7: "Bid Price 7",
    BIDPRICE8: "Bid Price 8",
    BIDPRICE9: "Bid Price 9",
    BIDAVERAGEPRICE: "Bid Average Price",
    BIDAMOUNT0: "Bid Volume 0",
    BIDAMOUNT1: "Bid Volume 1",
    BIDAMOUNT2: "Bid Volume 2",
    BIDAMOUNT3: "Bid Volume 3",
    BIDAMOUNT4: "Bid Volume 4",
    BIDAMOUNT5: "Bid Volume 5",
    BIDAMOUNT6: "Bid Volume 6",
    BIDAMOUNT7: "Bid Volume 7",
    BIDAMOUNT8: "Bid Volume 8",
    BIDAMOUNT9: "Bid Volume 9",
    BIDAMOUNTTOTAL: "Bid Volume Total",
    BIDQTY0: "Bid Qty 0",
    BIDQTY1: "Bid Qty 1",
    BIDQTY2: "Bid Qty 2",
    BIDQTY3: "Bid Qty 3",
    BIDQTY4: "Bid Qty 4",
    BIDQTY5: "Bid Qty 5",
    BIDQTY6: "Bid Qty 6",
    BIDQTY7: "Bid Qty 7",
    BIDQTY8: "Bid Qty 8",
    BIDQTY9: "Bid Qty 9",
    BIDQTYTOTAL: "Bid Qty Total",
    BIDTIME0: "Bid Time 0",
    BIDTIME1: "Bid Time 1",
    BIDTIME2: "Bid Time 2",
    BIDTIME3: "Bid Time 3",
    BIDTIME4: "Bid Time 4",
    BIDTIME5: "Bid Time 5",
    BIDTIME6: "Bid Time 6",
    BIDTIME7: "Bid Time 7",
    BIDTIME8: "Bid Time 8",
    BIDTIME9: "Bid Time 9",
    ASKPRICE0: "Ask Price 0",
    ASKPRICE1: "Ask Price 1",
    ASKPRICE2: "Ask Price 2",
    ASKPRICE3: "Ask Price 3",
    ASKPRICE4: "Ask Price 4",
    ASKPRICE5: "Ask Price 5",
    ASKPRICE6: "Ask Price 6",
    ASKPRICE7: "Ask Price 7",
    ASKPRICE8: "Ask Price 8",
    ASKPRICE9: "Ask Price 9",
    ASKAVERAGEPRICE: "Ask Average Price",
    ASKAMOUNT0: "Ask Volume 0",
    ASKAMOUNT1: "Ask Volume 1",
    ASKAMOUNT2: "Ask Volume 2",
    ASKAMOUNT3: "Ask Volume 3",
    ASKAMOUNT4: "Ask Volume 4",
    ASKAMOUNT5: "Ask Volume 5",
    ASKAMOUNT6: "Ask Volume 6",
    ASKAMOUNT7: "Ask Volume 7",
    ASKAMOUNT8: "Ask Volume 8",
    ASKAMOUNT9: "Ask Volume 9",
    ASKAMOUNTTOTAL: "Ask Volume Total",
    ASKQTY0: "Ask Qty 0",
    ASKQTY1: "Ask Qty 1",
    ASKQTY2: "Ask Qty 2",
    ASKQTY3: "Ask Qty 3",
    ASKQTY4: "Ask Qty 4",
    ASKQTY5: "Ask Qty 5",
    ASKQTY6: "Ask Qty 6",
    ASKQTY7: "Ask Qty 7",
    ASKQTY8: "Ask Qty 8",
    ASKQTY9: "Ask Qty 9",
    ASKQTYTOTAL: "Ask Qty Total",
    ASKTIME0: "Ask Time 0",
    ASKTIME1: "Ask Time 1",
    ASKTIME2: "Ask Time 2",
    ASKTIME3: "Ask Time 3",
    ASKTIME4: "Ask Time 4",
    ASKTIME5: "Ask Time 5",
    ASKTIME6: "Ask Time 6",
    ASKTIME7: "Ask Time 7",
    ASKTIME8: "Ask Time 8",
    ASKTIME9: "Ask Time 9",
    CONTRACTS: "Contracts",
    WOWLOW: "WOW Low",
    WOWLOWDATE: "WOW Low Date",
    WOWHIGH: "WOW High",
    WOWHIGHDATE: "WOW High Date",
    WOWPREVIOUSCLOSE: "WOW Previous Close",
    MOMLOW: "MOM Low",
    MOMLOWDATE: "MOM Low Date",
    MOMHIGH: "MOM High",
    MOMHIGHDATE: "MOM High Date",
    MOMPREVIOUSCLOSE: "MOM Previous Close",
    YOYLOW: "YOY Low",
    YOYLOWDATE: "YOY Low Date",
    YOYHIGH: "YOY High",
    YOYHIGHDATE: "YOY High Date",
    YOYPREVIOUSCLOSE: "YOY Previous Close",
    VALOR: "Valor",
    BIDRATE: "Bid Rate",
    ASKRATE: "Ask Rate",
    LASTTRADEDATE: "Last Trade Date",
    LASTRATE: "Last Rate",
    CY: "CY",
    DTM: "DTM",
    ACCRUEDINTEREST: "Accrued Interest",
    BIDSETTLEMENTPRICE: "Bid Settlement Price",
    ASKSETTLEMENTPRICE: "Ask Settlement Price",
    LASTSETTLEMENTPRICE: "Last Settlement Price",
    DTE: "DTE",
    SIMPLERATE: "Simple Rate",
    COMPOUNDRATE: "Compound Rate",
    MMVALOR: "MM Valor",
    TYPE: "Type",
    MMQUOTATION: "MM Quotation",
    MMQUOTERATE: "MM Quote Rate",
    MMQUOTEAMOUNT: "MM Quote Volume",
    CPI: "CPI",
    PREVIOUSCLOSERATE: "Previous Close Rate",
    PREVIOUSCLOSEDATE: "Previous Close Date",
    LOWRATE: "Low Rate",
    HIGHRATE: "High Rate",
    VALOR2: "Valor 2",
    DAYS: "Days",
    VWAR: "VWAR",
    DATE: "Date",
    WTDLOWDATE: "WTD Low Date",
    WTDHIGHDATE: "WTD High Date",
    MTDLOWDATE: "MTD Low Date",
    MTDHIGHDATE: "MTD High Date",
    YTDLOWDATE: "YTD Low Date",
    YTDHIGHDATE: "YTD High Date",
    EXPIREDATE: "Expire Date",
    CONTINOUSCODE: "Continous Code",
    INSTRUMENT: "Instrument",
    BOARD: "Board",
    SESSION: "Session",
    PREVIOUSSETTLEMENTPRICE: "Previous Settlement Price",
    SETTLEMENTPRICE: "Settlement Price",
    TOTALPREMIUM: "Total Premium",
    OPENINTEREST: "Open Interest",
    OPENINTERESTCHANGE: "Open Interest Change",
    UNDERLYINGSECURITY: "Underlying Security",
    OPTIONTYPE: "Option Type",
    OPTIONCLASS: "Option Class",
    STRIKEPRICE: "Strike Price",
    SECURITYGROUP: "Security Group",
    SECURITYGROUPNO: "Security Group No",
    LISTINGDATE: "Listing Date",
    CONTRACTMULTIPLIER: "Contract Multiplier",
    SETTLEMENTTYPE: "Settlement Type",
    PARENTCONTRACT: "Parent Contract",
    ACTIONTYPE: "Action Type",
    MARGINPERCENTAGE: "Margin Percentage",
    TRADINGUNITCOLLATERAL: "Trading Unit Collateral",
    CONTINOUSCODE2: "Continuous Code 2",
    FOREKSUNDERLYINGSECURITY: "Foreks UnderlyingSecurity",
    SECURITYCOUNT: "Security Count",
    SHORTNAME: "Short Name",
    SHORTNAMEENGLISH: "Short Name English",
    TRADECONDITION: "Trade Condition",
    SOURCE: "Source",
    STOCKS: "Stocks",
    TITLE: "Title",
    BIDTRADETOTALVOLUME: "Bid Trade Total Volume",
    ASKTRADETOTALVOLUME: "Ask Trade Total Volume",
    BIDTRADETOTALTURNOVER: "Bid Trade Total Turnover",
    ASKTRADETOTALTURNOVER: "Ask Trade Total Turnover",
    PRICESTEP: "Price Step",
    EQUILIBRIUMPRICE: "Equilibrium Price",
    EQUILIBRIUMVOLUME: "Equilibrium Volume",
    EPBIDAMOUNT: "EP Bid Volume",
    EPASKAMOUNT: "EP Ask Volume",
    CAPITAL: "Capital",
    PUBLICOFFERINGRATIO: "Public Offering Ratio",
    INDICES: "Indices",
    NETCAPITAL: "Net Capital",
    NETPROFIT: "Net Profit",
    LASTPERIOD: "Last Period",
    NOMINAL: "Nominal",
    ISIN: "ISIN",
    NETDIVIDEND: "Net Dividend",
    FREEFLOATRATE: "Free Float Rate",
    LASTPERIODPROFIT: "Last Period Profit",
    INDEXWEIGHT: "Index Weight",
    INDEXFFR: "Index FFR",
    ISSUER: "Issuer",
    GROSSSETTLEMENT: "Gross Settlement",
    MARKETVALUE: "Market Value",
    PRICEEARNING: "Price Earning",
    PUBLICSTOCKSIZE: "Public Stock Size",
    FREEFLOATSTOCKSIZE: "Free Float Stock Size",
    FREEFLOATMARKETVALUE: "Free Float Market Value",
    EARNIGPERSHARE: "Earning Per Share",
    DIVIDENDYIELD: "Dividend Yield",
    PRICEBOOKVALUE: "Price Book Value",
    BOOKVALUE: "Book Value",
    PLASMAN: "Plasman",
    PAYOUTRATIO: "Payout Ratio",
    SPREAD: "Spread",
    COUPONRATE: "Coupon Rate",
    PRICINGSOURCE: "Pricing Source",
    PRICINGSOURCENAME: "Pricing Source Name",
    BESTBIDTIME: "Best Bid Time",
    BESTASKTIME: "Best Ask Time",
    DELTA: "Delta",
    THETA: "Theta",
    GAMMA: "Gamma",
    VEGA: "Vega",
    RHO: "Rho",
    BARRIER: "Barrier",
    BSPRICE: "BS Price",
    BSDIFF: "BS Diff",
    BSCHANGEPERCENT: "BS Change Percent",
    SETTLEMENTCHANGE: "Settlement Change",
    SETTLEMENTCHANGEPERCENT: "Settlement Change Percent",
    XU030WEIGHT: "XU030 Weight",
    XU050WEIGHT: "XU050 Weight",
    XU100WEIGHT: "XU100 Weight",
    XUTUMWEIGHT: "XUTUM Weight",
    THEOPRICE21: "Theo Price 21",
    THEOPRICE42: "Theo Price 42",
    THEOPRICE63: "Theo Price 63",
    THEOPRICE126: "Theo Price 126",
    THEOPRICE252: "Theo Price 252",
    THEOPRICE: "Theo Price",
    THEOPRICECHANGE: "Theo Price Change",
    THEOPRICECHANGEPERCENT: "Theo Price Change Percent",
    HISVOL21: "His Vol 21",
    HISVOL42: "His Vol 42",
    HISVOL63: "His Vol 63",
    HISVOL126: "His Vol 126",
    HISVOL252: "His Vol 252",
    HISVOL30: "His Vol 30",
    TOTALCAPITAL: "Total Capital",
    LIQUIDASSETS: "Liquid Assets",
    PORTFOLIO: "Portfolio",
    EMM: "EMM",
    ASSET: "Asset",
    NUMOFSHARES: "Number Of Shares",
    OUTSTANDINGSHARES: "Outstanding Shares",
    PARTNERCOUNT: "Partner Count",
    BILLSPERCENTAGE: "Bills Percentage",
    BONDSPERCENTAGE: "Bonds Percentage",
    REVERSEREPOPERCENTAGE: "Reverse Repo Percentage",
    EQUITYPERCENTAGE: "Equity Percentage",
    PRIVATEDEBTSPERCENTAGE: "Private Debts Percentage",
    FOREIGNSECPERCENTAGE: "Foreign Sec Percentage",
    OTHERPERCENTAGE: "Other Percentage",
    NPDEBTPERCENTAGE: "NP Debt Percentage",
    EMMPERCENTAGE: "EMM Percentage",
    DAY91: "Day 91",
    DAY182: "Day 182",
    DAY273: "Day 273",
    DAY365: "Day 365",
    DAY456: "Day 456",
    DAYGEN: "Day Gen",
    OVERNIGHTEQUAL: "Over Night Equal",
    FUNDTYPE: "Fund Type",
    SIMPLELEVERAGE: "Simple Leverage",
    ACTIVELEVERAGE: "Active Leverage",
    SPOTPRICE: "Spot Price",
    SPOTPRICECHANGE: "Spot Price Change",
    SPOTPRICECHANGEPERCENT: "SpotPrice Change Percent",
    HIGHCHANGEPERCENT: "High Change Percent",
    LOWCHANGEPERCENT: "Low Change Percent",
    OPENCHANGEPERCENT: "Open Change Percent",
    FLUCTUATION: "Fluctuation",
    VWAPCHANGE: "VWAP Change",
    VWAPCHANGEPERCENT: "VWAP Change Percent",
    DIFFTOTALTURNOVER: "Diff Total Turnover",
    DIFFTOTALTURNOVERPERCENT: "Diff Total Turnover Percent",
    WARRANTRATE: "Warrant Rate",
    OPTIONSTATUS: "Option Status",
    NAME: "Name",
    DESCRIPTION: "Description",
    TICKER: "Ticker",
    MARKETSECTOR: "Market Sector",
    SECURITYTYPE: "Security Type",
    CURRENCY: "Currency",
    EXCHANGE: "Exchange",
    PRECISION: "Precision",
    EXERCISETYPE: "Exercise Type",
    BIDAMOUNT: "Bid Volume",
    ASKAMOUNT: "Ask Volume",
    DAILYDIRECTION: "Daily Direction",
    WOWEEKLYCHANGE: "WO Weekly Change",
    WOWEEKLYCHANGEPERCENT: "WO Weekly Change Percent",
    MOMONTHLYCHANGE: "MO Monthly Change",
    MOMONTHLYCHANGEPERCENT: "MO Monthly Change Percent",
    YOYEARLYCHANGE: "YO YearlyChange",
    YOYEARLYCHANGEPERCENT: "YO Yearly Change Percent",
    WTDVOLUME: "WTD Volume",
    WTDTURNOVER: "WTD Turnover",
    MTDVOLUME: "MTD Volume",
    MTDTURNOVER: "MTD Turnover",
    YTDVOLUME: "YTD Volume",
    YTDTURNOVER: "YTD Turnover",
    WOWVOLUME: "WOW Volume",
    WOWTURNOVER: "WOW Turnover",
    MOMVOLUME: "MOM Volume",
    MOMTURNOVER: "MOM Turnover",
    YOYVOLUME: "YOY Volume",
    YOYTURNOVER: "YOY Turnover",
    WEEKLYAVERAGEVOLUME: "Weekly Average Volume",
    WEEKLYAVERAGETURNOVER: "Weekly Average Turnover",
    WEEKLYAVERAGEVOLUME2: "Weekly Average Volume 2",
    WEEKLYAVERAGETURNOVER2: "Weekly Average Turnover 2",
    MONTHLYAVERAGEVOLUME: "Monthly Average Volume",
    MONTHLYAVERAGETURNOVER: "Monthly Average Turnover",
    MONTHLYAVERAGEVOLUME2: "Monthly Average Volume 2",
    MONTHLYAVERAGETURNOVER2: "Monthly Average Turnover 2",
    YEARLYAVERAGEVOLUME: "Yearly Average Volume",
    YEARLYAVERAGETURNOVER: "Yearly Average Turnover",
    YEARLYAVERAGEVOLUME2: "Yearly Average Volume 2",
    YEARLYAVERAGETURNOVER2: "Yearly Average Turnover 2",
    WAITINGBIDAMOUNT0: "Waiting Bid Volume 0",
    WAITINGBIDAMOUNT1: "Waiting Bid Volume 1",
    WAITINGBIDAMOUNT2: "Waiting Bid Volume 2",
    WAITINGBIDAMOUNT3: "Waiting Bid Volume 3",
    WAITINGBIDAMOUNT4: "Waiting Bid Volume 4",
    WAITINGBIDAMOUNT5: "Waiting Bid Volume 5",
    WAITINGBIDAMOUNT6: "Waiting Bid Volume 6",
    WAITINGBIDAMOUNT7: "Waiting Bid Volume 7",
    WAITINGBIDAMOUNT8: "Waiting Bid Volume 8",
    WAITINGBIDAMOUNT9: "Waiting Bid Volume 9",
    WAITINGASKAMOUNT0: "Waiting Ask Volume 0",
    WAITINGASKAMOUNT1: "Waiting Ask Volume 1",
    WAITINGASKAMOUNT2: "Waiting Ask Volume 2",
    WAITINGASKAMOUNT3: "Waiting Ask Volume 3",
    WAITINGASKAMOUNT4: "Waiting Ask Volume 4",
    WAITINGASKAMOUNT5: "Waiting Ask Volume 5",
    WAITINGASKAMOUNT6: "Waiting Ask Volume 6",
    WAITINGASKAMOUNT7: "Waiting Ask Volume 7",
    WAITINGASKAMOUNT8: "Waiting Ask Volume 8",
    WAITINGASKAMOUNT9: "Waiting Ask Volume 9",
    WAITINGBIDTURNOVER0: "Waiting Bid Turnover 0",
    WAITINGBIDTURNOVER1: "Waiting Bid Turnover 1",
    WAITINGBIDTURNOVER2: "Waiting Bid Turnover 2",
    WAITINGBIDTURNOVER3: "Waiting Bid Turnover 3",
    WAITINGBIDTURNOVER4: "Waiting Bid Turnover 4",
    WAITINGBIDTURNOVER5: "Waiting Bid Turnover 5",
    WAITINGBIDTURNOVER6: "Waiting Bid Turnover 6",
    WAITINGBIDTURNOVER7: "Waiting Bid Turnover 7",
    WAITINGBIDTURNOVER8: "Waiting Bid Turnover 8",
    WAITINGBIDTURNOVER9: "Waiting Bid Turnover 9",
    WAITINGASKTURNOVER0: "Waiting Ask Turnover 0",
    WAITINGASKTURNOVER1: "Waiting Ask Turnover 1",
    WAITINGASKTURNOVER2: "Waiting Ask Turnover 2",
    WAITINGASKTURNOVER3: "Waiting Ask Turnover 3",
    WAITINGASKTURNOVER4: "Waiting Ask Turnover 4",
    WAITINGASKTURNOVER5: "Waiting Ask Turnover 5",
    WAITINGASKTURNOVER6: "Waiting Ask Turnover 6",
    WAITINGASKTURNOVER7: "Waiting Ask Turnover 7",
    WAITINGASKTURNOVER8: "Waiting Ask Turnover 8",
    WAITINGASKTURNOVER9: "Waiting Ask Turnover 9",
    MARKETVALUEUSD: "Market Value USD",
    MARKETVALUEEUR: "Market Value EUR",
    LEVELCHANGE: "Level Change",
    SESSIONSTARTTIME: "Session Start Time",
    SESSIONENDTIME: "Session End Time",
    SESSIONDATE: "Session Date",
    PREVIOUSSESSIONDATE: "Previous Session Date",
    OPENFLAG: "Open Flag",
    RISKLEVEL: "Risk Level",
    GMT: "GMT",
    MATURITY: "Maturity",
    SMA5: "SMA5",
    SMA10: "SMA10",
    SMA20: "SMA20",
    SMA50: "SMA50",
    SMA100: "SMA100",
    SMA200: "SMA200",
    EMA5: "EMA5",
    EMA10: "EMA10",
    EMA20: "EMA20",
    EMA50: "EMA50",
    EMA100: "EMA100",
    EMA200: "EMA200",
    RSI14: "RSI14",
    MACD122609: "MACD122609",
    BOLUP2002: "BOLUP2002",
    BOLDOWN2002: "BOLDOWN2002",
    ADX14: "ADX14",
    DABTC: "DABTC",
    DASTC: "DASTC",
    DABTQ: "DABTQ",
    DASTQ: "DASTQ",
    DABSCR: "DABSCR",
    DABSQR: "DABSQR",
    DATBSCR: "DATBSCR",
    DATBSQR: "DATBSQR",
    DAWT: "DAWT",
    DAWAT: "DAWAT",
    DAWBT: "DAWBT",
    DAWST: "DAWST",
    DAOC: "DAOC",
    DATOC: "DATOC",
    DAOQ: "DAOQ",
    DATOQ: "DATOQ",
    DABOC: "DABOC",
    DASOC: "DASOC",
    DABOQ: "DABOQ",
    DASOQ: "DASOQ",
    DAFAKC: "DAFAKC",
    DAABQ: "DAABQ",
    DAASQ: "DAASQ",
    DAVBQ: "DAVBQ",
    DAVSQ: "DAVSQ",
    DACXC: "DACXC",
    DACXQ: "DACXQ",
    DACXBC: "DACXBC",
    DACXSC: "DACXSC",
    DACXBQ: "DACXBQ",
    DACXSQ: "DACXSQ",
    DATCXC: "DATCXC",
    DAWCX: "DAWCX",
    DAWCXB: "DAWCXB",
    DAWCXS: "DAWCXS",
    DACXCR: "DACXCR",
    DACXQR: "DACXQR",
    DATCXCR: "DATCXCR",
    DATCXQR: "DATCXQR",
    M1: "M1",
    M3: "M3",
    M6: "M6",
    M12: "M12",
    OPTIONPREMIUMTURNOVER: "Option Premium Turnover",
    LOCALE: "Locale",
    TAG: "Tag",
    NEWSID: "News Id",
    CONTENT: "Content",
    HEADER: "Header",
    SUMMARY: "Summary",
    TOPFIVEBROKERBIDTRADEVOLUME: "Top Five Broker Bid Trade Volume",
    TOPFIVEBROKERASKTRADEVOLUME: "Top Five Broker Ask Trade Volume",
    TOPFIVEBROKERNETTRADEVOLUME: "Top Five Broker Net Trade Volume",
    SNAPSHOT: "Snapshot",
    REALTRADENUMBER: "Real TradeNumber",
    TRADEID: "TradeId",
    FIXINGSETTLEMENTPRICE: "Fixing Settlement Price",
    PREVIOUSSETTLEMENTPRICECLOSE: "Previous Settlement Price Close",
    STATE: "State",
    TRADEOPERATION: "Trade Operation",
    ALPHA200: "Alpha 200",
    BETA200: "Beta 200",
    EQUILIBRIUMCHANGEPERCENT: "Equilibrium Change Percent",
    DIFFTOTALVOLUME: "Diff Total Volume",
    AVERAGERATE: "Average Rate",
    DATETIME: "Date Time",
    ESTIMATEDBIDPRICE: "Estimated Bid Price",
    ESTIMATEDASKPRICE: "Estimated Ask Price",
    BIDRATE0: "Bid Rate 0",
    BIDRATE1: "Bid Rate 1",
    BIDRATE2: "Bid Rate 2",
    BIDRATE3: "Bid Rate 3",
    BIDRATE4: "Bid Rate 4",
    BIDRATE5: "Bid Rate 5",
    BIDRATE6: "Bid Rate 6",
    BIDRATE7: "Bid Rate 7",
    BIDRATE8: "Bid Rate 8",
    BIDRATE9: "Bid Rate 9",
    ASKRATE0: "Ask Rate 0",
    ASKRATE1: "Ask Rate 1",
    ASKRATE2: "Ask Rate 2",
    ASKRATE3: "Ask Rate 3",
    ASKRATE4: "Ask Rate 4",
    ASKRATE5: "Ask Rate 5",
    ASKRATE6: "Ask Rate 6",
    ASKRATE7: "Ask Rate 7",
    ASKRATE8: "Ask Rate 8",
    ASKRATE9: "Ask Rate 9",
    NOMINALOPTIONPREMIUMTURNOVER: "Nominal Option Premium Turnover",
    TIMEMS: "Time Ms",
    MMQUOTETIME: "MM Quote Time",
    MMQUOTETYPE: "MM Quote Type",
    DEPTHTIME: "Depth Time",
    BIDQTY: "Bid Qty",
    ASKQTY: "Ask Qty",
    RATE: "Rate",
    OPENRATE: "Open Rate",
    MMQUOTEBROKER: "MM Quote Broker",
    MBOORDERKEY: "MBO Order Key",
    MBOBUYORSELL: "MBO Buy Or Sell",
    MBOORDERCLASS: "MBO Order Class",
    MBOPRICE: "MBO Price",
    MBOVOLUME: "MBO Volume",
    ADDITIONALREFERENCEPRICE: "Additional Reference Price",
    ACCUMULATEDTRADEREPORTVOLUME: "Accumulated TradeReport Volume",
    TOTALTURNOVERCURRENCY: "Total Turnover Currency",
    ACCUMULATEDTRADEREPORTTURNOVER: "Accumulated Trade Report Turnover",
    ACCUMULATEDTRADEREPORTTURNOVERCURRENCY: "Accumulated Trade Report Turnover Currency",
    TURNOVERCURRENCY: "Turnover Currency",
    TOPFIVEBROKERBIDTRADETURNOVER: "Top Five Broker Bid Trade Turnover",
    TOPFIVEBROKERASKTRADETURNOVER: "Top Five Broker Ask Trade Turnover",
    TOPFIVEBROKERNETTRADETURNOVER: "Top Five Broker Net Trade Turnover",
    TOPTENBROKERBIDTRADEVOLUME: "Top Ten Broker Bid Trade Volume",
    TOPTENBROKERASKTRADEVOLUME: "Top Ten Broker Ask Trade Volume",
    TOPTENBROKERNETTRADEVOLUME: "Top Ten Broker Net Trade Volume",
    TOPTENBROKERBIDTRADETURNOVER: "Top Ten Broker Bid Trade Turnover",
    TOPTENBROKERASKTRADETURNOVER: "Top Ten Broker Ask Trade Turnover",
    TOPTENBROKERNETTRADETURNOVER: "Top Ten Broker Net Trade Turnover",
    VWAPRATE: "VWAP Rate",
    VWAPSETTLEMENT: "VWAP Settlement",
    VWAPCOMPOUNDRATE: "VWAP Compound Rate",
    ATTACHMENTS: "Attachments",
    BIDCOLLATERALPRICE0: "Bid Collateral Price 0",
    BIDCOLLATERALPRICE1: "Bid Collateral Price 1",
    BIDCOLLATERALPRICE2: "Bid Collateral Price 2",
    BIDCOLLATERALPRICE3: "Bid Collateral Price 3",
    BIDCOLLATERALPRICE4: "Bid Collateral Price 4",
    BIDCOLLATERALPRICE5: "Bid Collateral Price 5",
    BIDCOLLATERALPRICE6: "Bid Collateral Price 6",
    BIDCOLLATERALPRICE7: "Bid Collateral Price 7",
    BIDCOLLATERALPRICE8: "Bid Collateral Price 8",
    BIDCOLLATERALPRICE9: "Bid Collateral Price 9",
    ASKCOLLATERALPRICE0: "Ask Collateral Price 0",
    ASKCOLLATERALPRICE1: "Ask Collateral Price 1",
    ASKCOLLATERALPRICE2: "Ask Collateral Price 2",
    ASKCOLLATERALPRICE3: "Ask Collateral Price 3",
    ASKCOLLATERALPRICE4: "Ask Collateral Price 4",
    ASKCOLLATERALPRICE5: "Ask Collateral Price 5",
    ASKCOLLATERALPRICE6: "Ask Collateral Price 6",
    ASKCOLLATERALPRICE7: "Ask Collateral Price 7",
    ASKCOLLATERALPRICE8: "Ask Collateral Price 8",
    ASKCOLLATERALPRICE9: "Ask Collateral Price 9",
    COLLATERALPRICE: "Collateral Price",
    TOPBIDTRADEBROKER: "Top Bid Trade Broker",
    TOPASKTRADEBROKER: "Top Ask Trade Broker",
    TOPTOTALTRADEBROKER: "Top Total Trade Broker",
    DAILYRATECHANGE: "Daily Rate Change",
    PIVOT: "Pivot",
    SUPPORT1: "Support 1",
    SUPPORT2: "Support 2",
    RESISTANCE1: "Resistance 1",
    RESISTANCE2: "Resistance 2",
    EQUILIBRIUMTURNOVER: "Equilibrium Turnover",
    OPENCOMPOUNDRATE: "Open Compound Rate",
    HIGHCOMPOUNDRATE: "High Compound Rate",
    LOWCOMPOUNDRATE: "Low Compound Rate",
    SEQUENCEID: "Sequence Id",
    MBOTIME: "MBO Time",
    MBOUPDATECODE: "MBO Update Code",
    PUBLICLEASECERTPERCENTAGE: "Public Lease Cert Percentage",
    PRIVATELEASECERTPERCENTAGE: "PrivateLease Cert Percentage",
    PRECIOUSMETALSPERCENTAGE: "Precious Metals Percentage",
    BANKBONDSPERCENTAGE: "Bank Bonds Percentage",
    FOREIGNBILLSOFEXCPERCENTAGE: "Foreign Bills Of ExcPercentage",
    FOREIGNDEPTHSOFEXCPERCENTAGE: "Foreign Depths Of ExcPercentage",
    EUROBONDSPERCENTAGE: "Eurobonds Percentage",
    COMMERCIALPAPERSPERCENTAGE: "Commercial Papers Percentage",
    FUNDCERTPERCENTAGE: "Fund Cert Percentage",
    REALESTATECERTPERCENTAGE: "Real Estate Cert Percentage",
    PARTICIPATIONACCPERCENTAGE: "Participation Acc Percentage",
    DERIVATIVESPERCENTAGE: "Derivatives Percentage",
    ASSETBACKEDSECPERCENTAGE: "Asset Backed Sec Percentage",
    TERMDEPOSITPERCENTAGE: "Term Deposit Percentage",
    FOREIGNDEBTSPERCENTAGE: "Foreign Debts Percentage",
    FOREIGNEQUITYPERCENTAGE: "Foreign Equity Percentage",
    REPOPERCENTAGE: "Repo Percentage",
    CROSSTRADE: "Cross Trade",
    TRADABLESTATUS: "Tradable Status",
    SENSITIVITY: "Sensitivity",
    AUCTIONPRICE: "P. Open",
    AUCTIONVOLUME: "P. Open Volume",
    FINALEVALUATION: "Final Evaluation",
    GRAPHIC: "Graphic",
    FGOLDD: "Gold D",
    FGOLD60M: "Gold D 60M",
    FGOLD15M: "Gold D 15M",
    FGOLD5M: "Gold D 5M",
    LEGACYCODE: "Legacy Code",
    RANKEDBIDPRICE0: "Ranked Bid Price 0",
    RANKEDBIDPRICE1: "Ranked Bid Price 1",
    RANKEDBIDPRICE2: "Ranked Bid Price 2",
    RANKEDBIDPRICE3: "Ranked Bid Price 3",
    RANKEDBIDPRICE4: "Ranked Bid Price 4",
    RANKEDBIDPRICE5: "Ranked Bid Price 5",
    RANKEDBIDPRICE6: "Ranked Bid Price 6",
    RANKEDBIDPRICE7: "Ranked Bid Price 7",
    RANKEDBIDPRICE8: "Ranked Bid Price 8",
    RANKEDBIDPRICE9: "Ranked Bid Price 9",
    RANKEDBIDAMOUNT0: "Ranked Bid Volume 0",
    RANKEDBIDAMOUNT1: "Ranked Bid Volume 1",
    RANKEDBIDAMOUNT2: "Ranked Bid Volume 2",
    RANKEDBIDAMOUNT3: "Ranked Bid Volume 3",
    RANKEDBIDAMOUNT4: "Ranked Bid Volume 4",
    RANKEDBIDAMOUNT5: "Ranked Bid Volume 5",
    RANKEDBIDAMOUNT6: "Ranked Bid Volume 6",
    RANKEDBIDAMOUNT7: "Ranked Bid Volume 7",
    RANKEDBIDAMOUNT8: "Ranked Bid Volume 8",
    RANKEDBIDAMOUNT9: "Ranked Bid Volume 9",
    RANKEDBIDORDERKEY0: "Ranked Bid Order Key 0",
    RANKEDBIDORDERKEY1: "Ranked Bid Order Key 1",
    RANKEDBIDORDERKEY2: "Ranked Bid Order Key 2",
    RANKEDBIDORDERKEY3: "Ranked Bid Order Key 3",
    RANKEDBIDORDERKEY4: "Ranked Bid Order Key 4",
    RANKEDBIDORDERKEY5: "Ranked Bid Order Key 5",
    RANKEDBIDORDERKEY6: "Ranked Bid Order Key 6",
    RANKEDBIDORDERKEY7: "Ranked Bid Order Key 7",
    RANKEDBIDORDERKEY8: "Ranked Bid Order Key 8",
    RANKEDBIDORDERKEY9: "Ranked Bid Order Key 9",
    RANKEDASKPRICE0: "Ranked Ask Price 0",
    RANKEDASKPRICE1: "Ranked Ask Price 1",
    RANKEDASKPRICE2: "Ranked Ask Price 2",
    RANKEDASKPRICE3: "Ranked Ask Price 3",
    RANKEDASKPRICE4: "Ranked Ask Price 4",
    RANKEDASKPRICE5: "Ranked Ask Price 5",
    RANKEDASKPRICE6: "Ranked Ask Price 6",
    RANKEDASKPRICE7: "Ranked Ask Price 7",
    RANKEDASKPRICE8: "Ranked Ask Price 8",
    RANKEDASKPRICE9: "Ranked Ask Price 9",
    RANKEDASKAMOUNT0: "Ranked Ask Volume 0",
    RANKEDASKAMOUNT1: "Ranked Ask Volume 1",
    RANKEDASKAMOUNT2: "Ranked Ask Volume 2",
    RANKEDASKAMOUNT3: "Ranked Ask Volume 3",
    RANKEDASKAMOUNT4: "Ranked Ask Volume 4",
    RANKEDASKAMOUNT5: "Ranked Ask Volume 5",
    RANKEDASKAMOUNT6: "Ranked Ask Volume 6",
    RANKEDASKAMOUNT7: "Ranked Ask Volume 7",
    RANKEDASKAMOUNT8: "Ranked Ask Volume 8",
    RANKEDASKAMOUNT9: "Ranked Ask Volume 9",
    RANKEDASKORDERKEY0: "Ranked Ask Order Key 0",
    RANKEDASKORDERKEY1: "Ranked Ask Order Key 1",
    RANKEDASKORDERKEY2: "Ranked Ask Order Key 2",
    RANKEDASKORDERKEY3: "Ranked Ask Order Key 3",
    RANKEDASKORDERKEY4: "Ranked Ask Order Key 4",
    RANKEDASKORDERKEY5: "Ranked Ask Order Key 5",
    RANKEDASKORDERKEY6: "Ranked Ask Order Key 6",
    RANKEDASKORDERKEY7: "Ranked Ask Order Key 7",
    RANKEDASKORDERKEY8: "Ranked Ask Order Key 8",
    RANKEDASKORDERKEY9: "Ranked Ask Order Key 9",
    MMQUOTEUPDATECODE: "MM Quote Update Code",
    CLEARINGTRADEINFO: "Clearing Trade Info",
    LIVESTATUS: "Live Status",
    TOPFIVEBROKERBIDTRADEVOLUME5M: "Top Five Broker Bid Trade Volume 5M",
    TOPFIVEBROKERASKTRADEVOLUME5M: "Top Five Broker Ask Trade Volume 5M",
    TOPFIVEBROKERNETTRADEVOLUME5M: "Top Five Broker Net Trade Volume 5M",
    TOPFIVEBROKERBIDTRADETURNOVER5M: "Top Five Broker Bid Trade Turnover 5M",
    TOPFIVEBROKERASKTRADETURNOVER5M: "Top Five Broker Ask Trade Turnover 5M",
    TOPFIVEBROKERNETTRADETURNOVER5M: "Top Five Broker Net Trade Turnover 5M",
    TOPFIVEBROKERBIDTRADEVOLUME10M: "Top Five Broker Bid Trade Volume 10M",
    TOPFIVEBROKERASKTRADEVOLUME10M: "Top Five Broker Ask Trade Volume 10M",
    TOPFIVEBROKERNETTRADEVOLUME10M: "Top Five Broker Net Trade Volume 10M",
    TOPFIVEBROKERBIDTRADETURNOVER10M: "Top Five Broker Bid Trade Turnover 10M",
    TOPFIVEBROKERASKTRADETURNOVER10M: "Top Five Broker Ask Trade Turnover 10M",
    TOPFIVEBROKERNETTRADETURNOVER10M: "Top Five Broker Net Trade Turnover 10M",
    CAPITALRATIO: "Capital Ratio",
    SHORTDEBTONTOTALASSETS: "Short Debt On Total Assets",
    SHORTDEBTONTOTALDEBT: "Short Debt On Total Debt",
    RETURNONEQUITY: "Return On Equity",
    SESSIONHIGH: "Session High",
    SESSIONLOW: "Session Low",
    SESSIONOPEN: "Session Open",
    SESSIONCHANGE: "Session Change",
    SESSIONCHANGEPERCENT: "Session Change Percent",
    SESSIONTOTALVOLUME: "Session Total Volume",
    SESSIONTOTALTURNOVER: "Session Total Turnover",
    SESSIONTOTALTURNOVERCURRENCY: "Session Total Turnover Currency",
    SESSIONVWAP: "Session VWAP",
    SESSIONCONTRACTS: "Session Contracts",
    BESTBID: "Best Bid",
    BESTASK: "Best Ask",
    BIDTRADECOUNT: "Bid Trade Count",
    ASKTRADECOUNT: "Ask Trade Count",
    UPTICKCOUNT: "Up Tick Count",
    UPTICKVOLUME: "Up Tick Volume",
    UPTICKTURNOVER: "Up Tick Turnover",
    DOWNTICKCOUNT: "Down Tick Count",
    DOWNTICKVOLUME: "Down Tick Volume",
    DOWNTICKTURNOVER: "Down Tick Turnover",
    SMA8: "SMA 8",
    EMA8: "EMA 8",
    PUBLICDOMESTICDEBTPERCENTAGE: "Public Domestic Debt Percentage",
    PUBLICLEASEFCPERCENTAGE: "Public Lease FC Percentage",
    REALESTATEINVESTMENTFUNDSPERCENTAGE: "Real Estate Investment Funds Percentage",
    PUBLICFOREIGNLEASEPERCENTAGE: "Public Foreign Lease Percentage",
    DEPOSITFCPERCENTAGE: "Deposit FC Percentage",
    PARTICIPATIONACCOUNTFCPERCENTAGE: "Participation Account FC Percentage",
    DEPOSITTLPERCENTAGE: "Deposit TL Percentage",
    PSFOREIGNLEASEPERCENTAGE: "PS Foreign Lease Percentage",
    FOREIGNPUBLICDEBTPERCENTAGE: "Foreign Public Debt Percentage",
    PRIVATEEXTERNALBORROWINGPERCENTAGE: "Private External Borrowing Percentage",
    TRADEDFUNDSPARTICIPATIONPERCENTAGE: "Traded Funds Participation Percentage",
    PUBLICDEBTPRECIOUSMETALSPERCENTAGE: "Public Debt Precious Metals Percentage",
    FOREIGNTRADEDFUNDSPERCENTAGE: "Foreign Traded Funds Percentage",
    PARTICIPATIONACCOUNTAUPERCENTAGE: "Participation Account AU Percentage",
    FOREIGNPRIVATESECTORDEBTPERCENTAGE: "Foreign Private Sector Debt Percentage",
    MUTUALFUNDSPARTICIPATIONPERCENTAGE: "Mutual Funds Participation Percentage",
    DEPOSITAUPERCENTAGE: "Deposit AU Percentage",
    PARTICIPATIONACCOUNTTLPERCENTAGE: "Participation Account TL Percentage",
    FUTURESCASHCOLLATERALSPERCENTAGE: "Futures Cash Collaterals Percentage",
    PRECIOUSMETALSETFPERCENTAGE: "Precious Metals ETF Percentage",
    PRIVATEEQUITYINVESTMENTFUNDSPERCENTAGE: "Private Equity Investment Funds Percentage",
    PUBLICLEASETLPERCENTAGE: "Public Lease TL Percentage",
    PUBLICLEASEPRECIOUSMETALSPERCENTAGE: "Public Lease Precious Metals Percentage",
    BIDPRICE10: "Bid Price 10",
    BIDQTY20: "Bid Qty 20",
    BIDQTY24: "Bid Qty 24",
    ASKPRICE13: "Ask Price 13",
    ASKPRICE17: "Ask Price 17",
    BIDQTY11: "Bid Qty 11",
    BIDQTY15: "Bid Qty 15",
    ASKPRICE10: "Ask Price 10",
    ASKPRICE14: "Ask Price 14",
    ASKAMOUNT10: "Ask Volume 10",
    BIDPRICE13: "Bid Price 13",
    ASKPRICE21: "Ask Price 21",
    BIDPRICE21: "Bid Price 21",
    BIDAMOUNT15: "Bid Volume 15",
    BIDAMOUNT16: "Bid Volume 16",
    ASKPRICE23: "Ask Price 23",
    ASKAMOUNT12: "Ask Volume 12",
    ASKAMOUNT13: "Ask Volume 13",
    ASKAMOUNT18: "Ask Volume 18",
    ASKQTY17: "Ask Qty 17",
    ASKQTY23: "Ask Qty 23",
    BIDPRICE12: "Bid Price 12",
    BIDQTY22: "Bid Qty 22",
    BIDAMOUNT18: "Bid Volume 18",
    BIDQTY23: "Bid Qty 23",
    ASKQTY21: "Ask Qty 21",
    ASKPRICE20: "Ask Price 20",
    ASKAMOUNT20: "Ask Volume 20",
    BIDPRICE18: "Bid Price 18",
    BIDPRICE11: "Bid Price 11",
    BIDPRICE19: "Bid Price 19",
    ASKPRICE12: "Ask Price 12",
    ASKPRICE15: "Ask Price 15",
    ASKAMOUNT24: "Ask Volume 24",
    ASKQTY11: "Ask Qty 11",
    ASKQTY19: "Ask Qty 19",
    BIDAMOUNT10: "Bid Volume 10",
    BIDQTY10: "Bid Qty 10",
    ASKAMOUNT16: "Ask Volume 16",
    ASKAMOUNT22: "Ask Volume 22",
    ASKQTY18: "Ask Qty 18",
    BIDAMOUNT19: "Bid Volume 19",
    BIDPRICE20: "Bid Price 20",
    BIDAMOUNT21: "Bid Volume 21",
    BIDQTY14: "Bid Qty 14",
    ASKPRICE16: "Ask Price 16",
    ASKQTY13: "Ask Qty 13",
    ASKQTY16: "Ask Qty 16",
    BIDAMOUNT14: "Bid Volume 14",
    BIDQTY19: "Bid Qty 19",
    BIDQTY21: "Bid Qty 21",
    ASKAMOUNT11: "Ask Volume 11",
    ASKAMOUNT17: "Ask Volume 17",
    ASKQTY14: "Ask Qty 14",
    BIDAMOUNT13: "Bid Volume 13",
    BIDPRICE24: "Bid Price 24",
    BIDQTY18: "Bid Qty 18",
    ASKPRICE22: "Ask Price 22",
    ASKQTY20: "Ask Qty 20",
    BIDAMOUNT11: "Bid Volume 11",
    BIDAMOUNT12: "Bid Volume 12",
    BIDAMOUNT22: "Bid Volume 22",
    BIDQTY13: "Bid Qty 13",
    BIDQTY16: "Bid Qty 16",
    ASKAMOUNT14: "Ask Volume 14",
    ASKAMOUNT23: "Ask Volume 23",
    ASKQTY10: "Ask Qty 10",
    ASKQTY22: "Ask Qty 22",
    BIDPRICE16: "Bid Price 16",
    BIDPRICE17: "Bid Price 17",
    BIDPRICE22: "Bid Price 22",
    BIDPRICE23: "Bid Price 23",
    ASKAMOUNT19: "Ask Volume 19",
    ASKQTY12: "Ask Qty 12",
    BIDPRICE14: "Bid Price 14",
    BIDPRICE15: "Bid Price 15",
    BIDQTY17: "Bid Qty 17",
    ASKPRICE11: "Ask Price 11",
    ASKPRICE24: "Ask Price 24",
    ASKAMOUNT15: "Ask Volume 15",
    BIDAMOUNT24: "Bid Volume 24",
    ASKPRICE18: "Ask Price 18",
    ASKPRICE19: "Ask Price 19",
    BIDAMOUNT17: "Bid Volume 17",
    BIDAMOUNT20: "Bid Volume 20",
    BIDAMOUNT23: "Bid Volume 23",
    BIDQTY12: "Bid Qty 12",
    ASKAMOUNT21: "Ask Volume 21",
    ASKQTY15: "Ask Qty 15",
    ASKQTY24: "Ask Qty 24",
    NEWSSOURCEREF: "News Source Ref",
    SPLITRATIO: "Split Ratio",
    LASTINCURRENCY: "Last In Currency",
    TOTALTRADECOUNT: "Total Trade Count",
    NEWSBEHALFFUNDTITLE: "News Behalf Fund Title",
    NEWSBEHALFFUNDID: "News Behalf Fund Id",
    SPLITRATIODATE: "Split Ratio Date",
    REALESTATEINVESTMENTS: "Real Estate Investments",
    VENTURECAPITALINVESTMENTS: "Venture Capital Investments",
    FGOLD240M: "F Gold 240M",
    INTRAYEARCLOSE: "Intra-Year Close",
    INTRAYEARCHANGE: "Intra-Year Change",
    INTRAYEARCHANGEPERCENT: "Intra-Year Change %",
    INTRAWEEKCLOSE: "Intra-Week Close",
    INTRAWEEKCHANGE: "Intra-Week Change",
    INTRAWEEKCHANGEPERCENT: "Intra-Week Change %",
    INTRAMONTHCLOSE: "Intra-Month Close",
    INTRAMONTHCHANGE: "Intra-Month Change",
    INTRAMONTHCHANGEPERCENT: "Intra-Month Change %",
    INSTITUTIONALINVESTORSTOCKSIZE: "Institutional Investor Stock Size",
    INSTITUTIONALINVESTORRATIO: "Institutional Investor Ratio",
    INDIVIDUALINVESTORSTOCKSIZE: "Individual Investor Stock Size",
    INDIVIDUALINVESTORRATIO: "Individual Investor Ratio",
    FOREIGNSETTLEMENTRATIO: "Foreign Settlement Ratio",
    FIRSTBROKERBIDTOTALVOLUME: "1st Broker Bid Total Volume",
    FIRSTBROKERBIDTOTALTURNOVER: "1st Broker Bid Total Turnover",
    FIRSTBROKERASKTOTALVOLUME: "1st Broker Ask Total Volume",
    FIRSTBROKERASKTOTALTURNOVER: "1st Broker Ask Total Turnover",
    SECONDBROKERBIDTOTALVOLUME: "2nd Broker Bid Total Volume",
    SECONDBROKERBIDTOTALTURNOVER: "2nd Broker Bid Total Turnover",
    SECONDBROKERASKTOTALVOLUME: "2nd Broker Ask Total Volume",
    SECONDBROKERASKTOTALTURNOVER: "2nd Broker Ask Total Turnover",
    SECONDBIDTRADEBROKER: "2nd Bid Trade Broker",
    SECONDASKTRADEBROKER: "2nd Ask Trade Broker",
    BIDCOLLATERALPRICE: "Bid Collateral Price",
    ASKCOLLATERALPRICE: "Ask Collateral Price",
    PSR: "PSR",
    LEVERAGERATIO: "Leverage Ratio",
    INVESTORCOUNT: "Investor Count"
  }

};
